import { computable, iterator, observable } from "@chorda/core";
import { Box } from "chorda-bulma";
import { Coerced } from "../../utils";
import { USERS } from "../../data";
import { ListBox, ListBoxItem } from "./ListBox";
const users = observable(USERS.slice(10, 14), (v) => v.id.value);
export default () => {
    return Box({
        css: 'is-paddingless centered-narrow-box',
        content: Coerced({
            as: ListBox({
                defaultItem: Coerced({
                    as: ListBoxItem({
                        text$: ({ data }) => computable(() => `${data.name.first} ${data.name.last}`),
                        image$: ({ data }) => data.picture.thumbnail,
                        subtitle$: ({ data }) => data.email
                    })
                })
            }),
            reactions: {
                data: (v) => ({ items: iterator(v, 'data') })
            },
            defaults: {
                data: () => users // iterable(users, 'data')
            }
        })
    });
};
